// extracted by mini-css-extract-plugin
export default {"imgWrapper":"BannerCarousel_imgWrapper__HxIBz"};